module.exports = __webpack_public_path__ + "static/media/calendar-day-solid.b069ecfb.svg";